import React, { useState } from 'react';
import formatNumber from '../../../helpers/NumberFormat';
import { useScheduleCallMutation } from 'services/clientApi';
import { MdMissedVideoCall } from 'react-icons/md';
import { BiSupport } from 'react-icons/bi';
import { TiTickOutline } from "react-icons/ti";
import moment from 'moment';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import './RequestAppointment.scss';

export default function RequestAppointmentComponent({ isMobile, mainProps, showSidebar }) {
    const navigate = useNavigate()
    const { main } = mainProps;
    const [schedule] = useScheduleCallMutation();
    const [data, setData] = useState({
        title: '',
        start_date: '',
        time: '',
        description: '',
    });
    const [formStep1SelectedOption, setFormStep1SelectedOption] = useState('');
    const phoneNo = main?.user?.detail?.otp_phone_nr || "";
    const maskedPhone = phoneNo.length > 4
        ? phoneNo.slice(0, -4).replace(/\d/g, '*') + phoneNo.slice(-4)
        : phoneNo;
    const [errors, setErrors] = useState({});

    const handleSumbit = async (e) => {
        e.preventDefault();

        const newErrors = {};
        if (!data.title) newErrors.title = true;
        if (!data.start_date) newErrors.start_date = true;
        if (!data.time) newErrors.time = true;
        if (!data.description) newErrors.description = true;

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return toast.warn('Please fill in all the fields.');
        }

        if (formStep1SelectedOption !== 'SUPPORT')
            return toast.warn('Please choose your preferred mode of communication before proceeding with your appointment submission.');

        const result = await schedule({
            start_date: moment(`${data.start_date} ${data.time}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm:ss"),
            title: data.title,
            description: data.description,
        });

        if ("error" in result) {
            console.log("error", result);
        } else {
            setData({ title: '', start_date: '', time: '', description: '' });
            setErrors({});
            toast.success("Appointment was reserved successfully. We will get in touch soon!");
            navigate('/calendar-appointments');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });

        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: false }));
        }
    };

    return (
        <div
            className="container-fluid bg-col transition-width"
            style={
                !isMobile
                    ? {
                        width: showSidebar ? 'calc(100% - 332px)' : '100%',
                        marginLeft: 0,
                        marginRight: 'auto',
                        transition: showSidebar ? 'width 0.3s ease-in-out' : 'width 0.16s ease-in-out'
                    }
                    : {}
            }
        >
            <div className="row p-3 reports-panel" style={{ borderBottom: '2px solid #EFEFEF' }}>
                <h5 className="mb-4 mt-2 fw-semibold">REQUEST AN APPOINTMENT</h5>
                <div className="text-muted mb-4">
                    <p>Through this section you have the opportunity to make an appointment with your banking specialist.</p>
                </div>

                <div className="mb-4">
                    <label className="form-label"><strong>What topic do you want to talk about?</strong></label>
                    <input
                        type="text"
                        className={`form-control ${isMobile ? "w-100" : "w-50"} ${errors.title ? "is-invalid" : ""}`}
                        name="title"
                        value={data.title}
                        onChange={handleChange}
                        placeholder="e.g. Investment advice, Account issue..."
                    />
                    {errors.title && <div className="invalid-feedback d-block">Please enter a topic.</div>}
                </div>

                <div className="row g-3 mb-4 p-0 m-0">
                    {[
                        {
                            key: 'SUPPORT',
                            icon: <BiSupport size={40} />,
                            title: 'Real-Time Support',
                            subtitle: `You will be contacted at this phone number ${maskedPhone}.`,
                            disabled: false,
                        },
                        {
                            key: 'VIDEO',
                            icon: <MdMissedVideoCall size={40} />,
                            title: 'Video Call',
                            subtitle: 'Schedule a video call with your advisor.',
                            disabled: true,
                        },
                    ].map((opt) => {
                        const isSelected = formStep1SelectedOption === opt.key;
                        const isDisabled = opt.disabled;

                        return (
                            <div key={opt.key} className="col-md-6 d-flex">
                                <div
                                    onClick={() => {
                                        if (!isDisabled) setFormStep1SelectedOption(opt.key);
                                    }}
                                    className={`card w-100 d-flex flex-column justify-content-between position-relative ${isSelected ? 'border-appointment-secondary' : ''} ${isDisabled ? 'opacity-50' : ''}`}
                                    style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                                >
                                    <div className="text-center d-flex flex-column align-items-center p-3 flex-grow-1">
                                        <div className={`${isSelected ? 'text-appointment-secondary' : 'text-muted'}`}>
                                            {opt.icon}
                                        </div>
                                        <div className="mt-2 text-center">
                                            <h5 className="card-title mb-1">{opt.title}</h5>
                                            <p className="text-muted mb-0">{opt.subtitle}</p>
                                        </div>
                                    </div>

                                    <div
                                        className={`text-center d-flex justify-content-center align-items-center gap-2 choose-line ${isSelected ? 'color-white' : 'text-muted'}`}
                                        style={{
                                            height: '50px',
                                            borderTop: '1px solid #ddd',
                                            fontSize: '0.9rem',
                                            backgroundColor: isSelected ? "#6A343A" : "#ddd"
                                        }}
                                    >
                                        {isSelected ? <TiTickOutline size={35} /> : 'CHOOSE'}
                                    </div>

                                    {isDisabled && <div className="coming-soon-overlay"></div>}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="row my-4 p-0 m-0">
                    <div className="col-md-6 mb-3">
                        <label className="form-label"><strong>Choose date</strong></label>
                        <input
                            type="date"
                            className={`form-control ${errors.start_date ? "is-invalid" : ""}`}
                            name="start_date"
                            value={data.start_date}
                            min={new Date().toISOString().slice(0, 10)}
                            onChange={handleChange}
                        />
                        {errors.start_date && <div className="invalid-feedback d-block">Please select a date.</div>}
                    </div>

                    <div className="col-md-6 mb-3">
                        <label className="form-label"><strong>Choose time</strong></label>
                        <input
                            type="time"
                            className={`form-control ${errors.time ? "is-invalid" : ""}`}
                            name="time"
                            value={data.time}
                            onChange={handleChange}
                        />
                        {errors.time && <div className="invalid-feedback d-block">Please select a time.</div>}
                    </div>
                </div>

                <div className="mb-4">
                    <label className="form-label"><strong>Description</strong></label>
                    <textarea
                        name="description"
                        className={`form-control ${errors.description ? "is-invalid" : ""}`}
                        rows="4"
                        placeholder="Tell us more about what you want to discuss or the specialist that you are interested to contact with..."
                        value={data.description}
                        onChange={handleChange}
                    ></textarea>
                    {errors.description && <div className="invalid-feedback d-block">Please provide a description.</div>}
                </div>


                <div className="d-flex justify-content-end my-5">
                    <button onClick={handleSumbit} className={`btn submit-appointment rounded px-4 ${isMobile ? "w-100 mt-4" : "w-25"}`}>
                        Submit Appointment
                    </button>
                </div>
            </div>
        </div>
    );
}